import Dialog from 'material-ui/Dialog';
import * as React from 'react';
import ReactPlayer from 'react-player';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {ModuleModel} from '../../model/ModuleModel';
import {UserModel} from '../../model/UserModel';
import {getModuleDetails} from '../../services/moduleService';
import {userUniqueID} from '../../utils/generalUtils';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {CustomFlatButton} from '../reusableComponents/CutomFlatButton';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {Icon} from '../reusableComponents/Icon';
import {Loader} from '../reusableComponents/Loader/Loader';
import {PerfectScrollbar} from '../reusableComponents/PerfectScrollbar';
import {DeleteModuleDialog} from './DeleteModuleDialog';
import './modules.scss';

export interface IModuleDetailsPageProps {
    moduleInstance: ModuleModel;
    moduleID: string;
    userID: string;
    history: IHistory;
    userInstance: UserModel;
}

export interface IModuleDetailsPageState {
    open: boolean;
    acknowledgementDone: boolean;
}

export class ModuleDetailsPageImpl extends React.Component<IModuleDetailsPageProps, IModuleDetailsPageState> {
    constructor(props: IModuleDetailsPageProps) {
        super(props);
        this.state = {open: false, acknowledgementDone: false};
    }

    public promise = async () => {
        await getModuleDetails(this.props.moduleID, this.props.userID);
    }

    public renderAcknowledgement = () => {
        const {moduleInstance: {props: {Name, ModuleID}}} = this.props;
        const actions = [
            <CustomFlatButton
                label="No"
                color={'black'}
                primary={true}
                onClick={() => this.setState({acknowledgementDone: false})}
            />,
            <CustomFlatButton
                label="Yes"
                color={'black'}
                primary={true}
                onClick={() =>
                    this.props.history.push(`/training/start-test/${Name}/${ModuleID}`)}
            />
        ];
        return <Dialog
            title="Acknowledgement"
            actions={actions}
            modal={true}
            open={this.state.acknowledgementDone}
        >
            This is to acknowledge that you have read all the documents attached to this module and went through
            the links and read that all.
            Click on Yes to accept the acknowledgement or No to go back and read again.
        </Dialog>;
    }

    public renderModuleDetails = () => {
        if (!this.props.moduleInstance) {
            return <Loader type="async"/>;
        }
        const {props: {Name: ModuleName, Links, ContinueLater, Questions, Description, id, ModuleID, DueDate, Completed, TrainingDuration, MinimumMarksToPass, DateCreated, DateCompleted, ModuleType, Instructions}} = this.props.moduleInstance;
        const isAdmin = UserModel.isAdmin(this.props.userInstance) || UserModel.isSuperAdmin(this.props.userInstance);
        const Name = ModuleName.replace(/#|\//g, '-');
        const isInstruction = ModuleType === 'Instruction Module';
        
        return <div className="details-page">
            {/* {this.renderAcknowledgement()} */}
            <DeleteModuleDialog
                onClose={() => this.setState({open: false})}
                open={this.state.open}
                moduleIds={[ModuleID]}
                textToDisplay={Name}
                history={this.props.history}
            />
            <div className="container">
                <div className="details">
                    <div className="label">Training Module Name:</div>
                    <div className="value">{Name || 'NA'}</div>
                </div>
            </div>
            <div className="container">
                <div className="details">
                    <div className="label">Training Module Description:</div>
                    <div className="value">{Description || 'NA'}</div>
                </div>
            </div>

            {isAdmin && <div className="container">
                <div className="details">
                    <div className="label">Date Created:</div>
                    <div className="value">{DateCreated || 'NA'}</div>
                </div>
            </div>}
            {!isInstruction && (
                <div className="container">
                    <div className="details">
                        <div className="label">Minimum Marks to pass:</div>
                        <div className="value">{MinimumMarksToPass || 'NA'}</div>
                    </div>
                </div>
            )}
            <div className="container">
                <div className="details">
                    <div className="label">Training Period:</div>
                    <div className="value">{TrainingDuration + ' Day(s)' || 'NA'}</div>
                </div>
            </div>
            {
                !isAdmin ? <div>
                        <div className="container">
                            <div className="details">
                                <div className="label">Due Date:</div>
                                <div className="value">{DueDate || 'NA'}</div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="details">
                                <div className="label">Status:</div>
                                <div className="value">{Completed ? 'Completed' : 'Pending'}</div>
                            </div>
                        </div>
                        <div className="container">
                            <div className="details">
                                <div className="label">Completed Date:</div>
                                <div className="value">{DateCompleted || 'NA'}</div>
                            </div>
                        </div>
                    </div>
                    : ' '
            }
            <div className="container">
                <div className="details">
                    <div className="label"> Training Module Links:</div>
                    <PerfectScrollbar className="value links-container">
                        {(Links || []).map((linkData, index) => {
                            return <div key={index} className="link">
                                {linkData.link.endsWith('.mp4')
                                    ? <view>
                                        < ReactPlayer
                                            config={{
                                                file:
                                                    {
                                                        attributes:
                                                            {controlsList: 'nodownload'}
                                                    }
                                            }}
                                            onContextMenu={e => e.preventDefault()}
                                            url={linkData.link}
                                            className="react-player"
                                            controls
                                            width="100%"
                                            height="100%"
                                        /></view>
                                    : <view>
                                        <Icon icon="link"/>
                                        <a key={index} href={linkData.link}
                                           className="url" target="popup">
                                            {linkData.title}</a></view>
                                }
                            </div>;
                        })}
                    </PerfectScrollbar>
                </div>
            </div>
            {isAdmin && !isInstruction ? <div className="questions-container">
                    <div className="header">Questions:</div>
                    <div className="headings box">
                        <div className="ques-num">
                            #
                        </div>
                        <div className="question">
                            Question
                        </div>
                        <div className="answer">
                            Answer
                        </div>
                    </div>
                    <PerfectScrollbar className="value que-ans-container">
                        {(Questions || []).map((quesData, index) => {
                            return <div key={index} className="questions">
                                <div className="ques-num">
                                    {quesData.questionNum}
                                </div>
                                <div className="question">
                                    {quesData.question}
                                </div>
                                <div className="answer">
                                    {quesData.CorrectAnswer}
                                </div>
                            </div>;
                        })}
                    </PerfectScrollbar>
                </div>
                : ''}
            {isAdmin ? <div className="options-container">
                    <div className="delete" onClick={() => this.setState({open: true})}>
                        <Icon icon="trash"/>
                        &nbsp;
                        Delete
                    </div>
                    <div className="add-new"
                         onClick={() => this.props.history.push(`/training/edit/${id}`)}
                    >
                        <Icon icon="pencil-alt"/>
                        &nbsp;
                        Edit
                    </div>
                </div> :
                <div className="options-container">
                    <div className="delete"
                         onClick={() => this.props.history.push(`/training/start-test/${Name}/${ModuleID}`)}
                    >
                        <Icon icon="question-circle"/>
                        &nbsp;
                        {isInstruction ? 'Start Instruction' : (ContinueLater ? 'Continue Test' : 'Start Test')}
                    </div>
                </div>}
        </div>;
    }

    public render() {
        return <BasePage icon="chalkboard-teacher" className="module-details" title="Module Details">
            <Async
                identifier="ModuleDetails"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={this.renderModuleDetails()}
                error={<ErrorPage/>}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const moduleID = ownProps.match.params.id;
    const moduleInstance = ModuleModel.get(moduleID);
    const userInstance = UserModel.get(userUniqueID(state));
    return {
        userID: userUniqueID(state),
        moduleID,
        moduleInstance,
        userInstance
    };
}

export const ModuleDetailsPage =
    withRouter(connect<{}, {}, IModuleDetailsPageProps>(mapStateToProps)(ModuleDetailsPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/ModuleDetailsPage.tsx